<!-- book 页面模版 -->
<template>
  <div class="template-container">
    <v-header :book_on="editable"></v-header>
    <main class="article-detail-main" :style="{ width: isZoom ? fullScreen : '1200px' }">
      <!-- 左侧导航目录 -->
      <div class="detail-left" v-if="!isZoom && !user404">
        <!-- 用户信息 -->
        <div class="user-info">
          <img v-if="currentUserInfo.pic" :src="currentUserInfo.pic" class="avatar" />
          <img class="avatar" src="~/assets/img/anonymous.png" v-else />

          <div class="user-introduce">
            <p class="user-name bold">{{ currentUserInfo.nick}}</p>
            <p class="article-num">文章：{{ currentUserInfo.num }}</p>
            <p>
              <span style="display: inline-block">关注：{{ currentUserInfo.guanzhu}}</span>
              <span style="display: inline-block">粉丝：{{ currentUserInfo.fensi }}</span>
            </p>
          </div>

          <div style="flex:1; text-align: right;">
            <el-button class="follow-btn" type="primary" :plain="!currentUserInfo.follow" @click="handleFollow">
              {{ currentUserInfo.follow ? '已关注' : '关注'}}
            </el-button>
          </div>
        </div>
        <!-- 搜索当页搜索框 -->
        <div class="struct-title">
          <el-input
            class="custom-input"
            placeholder="搜索当前页内容"
            v-model="searchStruct"
            @keyup.enter.native="doSearchStruct"
          >
            <div slot="prefix" class="prefix-wrap" @click="doSearchStruct">
              <img class="" src="~/assets/img/sousuo.png" alt="">
            </div>
          </el-input>
        </div>

        <!-- 用户文章列表 -->
        <div class="struct-panel">
          <div class="tree-box">
            <tree
              :editable="editable"
              @onSyncRepo="onSyncRepo"
              :flatData="flatUserStruct"
              :treeData="user_struct"
              @handleFileClick="handleFileClick"
            />
          </div>
        </div>
      </div>

      <!-- 中间内容区域和右侧的文章目录 -->
      <nuxt-child v-if="!user404"></nuxt-child>
      <div style="height: 100%; display: flex; align-items: center; justify-content: center;" v-if="user404">
        <img src="~/assets/img/book-404.png"/>
      </div>

      <offcanvas-bar :visible="show_right_menu" width="85%" bg-color="#FFF" potion="left"
                     @close="show_right_menu=false" @open="handleLeftOpen">
        <h1 style="text-align: center;border-bottom: 1px solid #eee; padding-bottom: 5px;">用户目录</h1>
        <tree
          :editable="editable"
          :treeData="user_struct"
          @handleFileClick="handleFileClick"
          :flatData="flatUserStruct"
          :show_right_menu="show_right_menu"
        />
      </offcanvas-bar>

    </main>
  </div>
</template>

<script>
  import VHeader from "~/components/home/header";
  import {followUser, getUserArticleList} from "~/utils/api";
  import Tree from "~/components/tree";
  import {errorMsg, successMsg, flatObjArr} from "~/utils/tools";
  import {SUCCESS} from "~/utils/status-code";
  import OffcanvasBar from "~/components/offcanvas-bar";
  import {mapState} from 'vuex';
  import * as apis from '~/utils/api';
  import VLogin from '~/components/login'

  // 在浏览器中执行时，被 asyncData 调用，直接返回 {}
  const initData = async (route, store, redirect, fromAsyncData = false) => {
    if (process.client ^ fromAsyncData) {
      const {detail} = route.params;
      let {uid} = route.params;

      await store.dispatch('auth/getUserInfo');
      if (!uid) {
        if (store.state.auth.isLogin) {
          handleRedirect({}, store.state.auth.userInfo.uid, '', redirect);
        } else {
          // 这个移动到了 mounted 中，http://zentao.uninote.com.cn/zentao/bug-view-30.html
          // store.commit("auth/SHOW_LOGIN", true);
        }
        return {};
      }
      try {
        const {data: currentUserInfo} = await apis.getAnyUserInfo(uid);
        const res = await getUserArticleList(uid);
        handleRedirect(res, uid, detail, redirect);
        return {
          inited: true,
          currentUserInfo,
          resArticleList: res,
          user_struct: [{name: "用户根目录", path: "", child: res.data, type: 'dir', isMaster: true}]
        }
      } catch (e) {
        const user404 = e && e.errno === -1202;
        return {
          inited: true,
          user404,
        };
      }
    } else {
      return {};
    }
  };

  /**
   * 重定向处理
   *
   * 服务器显式要求重定向（username 兼容） 或者 非 /book/uid/detail 形式时；uid 一定要传入
   */
  const handleRedirect = (data, uid, detail, redirect) => {
    if (!data || !uid) {
      console.error("data or uid is empty");
      return;
    }
    if (data.redirect) {
      return redirect(`/book/${data.data}`);
    }
    if (uid && detail) {
      // 无需 redirect
      return;
    }
    if (!detail && data.data) {
      const README = data.data.find((element) => (element.path.toUpperCase() === "README.MD"));
      // 如果没有README.MD则直接去第一个进行展示
      detail = `${README ? README.id : data.data[0].id}`;
      return redirect(`/book/${uid}/${detail}`);
    }
  };

  export default {
    name: "book",
    components: {Tree, VHeader, OffcanvasBar, VLogin},

    data() {
      return {
        inited: false,
        resArticleList: null,
        show_right_menu: false,
        // 当前页面的用户信息
        currentUserInfo: {
          id: 0,
          nick: "",
          pic: "",
          num: 0,
          guanzhu: 0,
          fensi: 0,
          follow: false,
        },
        user404: false,
        searchStruct: '',
        // 用户目录列表
        user_struct: [],
        structName: '',
        fullScreen: '1200px',
        normalScreen: '960px',
      }
    },

    computed: {
      ...mapState('auth', [
        'userInfo',
      ]),
      ...mapState('editor', [
        'isZoom',
      ]),
      flatUserStruct() {
        return flatObjArr(this.user_struct, 'child');
      },

      // 可编辑才显示菜单
      editable() {
        return this.$route.params.uid === this.userInfo.id;
      },
    },

    /**
     * 在页面加载前从 localStorage 中获取用户信息
     */
    async mounted() {
      window.addEventListener('resize', this.onResize);
      this.onResize();
      this.registerBus();

      // 不能放 asyncData 中，http://zentao.uninote.com.cn/zentao/bug-view-30.html
      if (!this.$store.state.auth.isLogin && !this.$route.params.uid) {
        this.$store.commit("auth/SHOW_LOGIN", true);
      }

      // 只有在 ssr 时，inited === true；其他情况，数据的初始化延迟到这里
      if (!this.inited) {
        const data = await initData(this.$route, this.$store, (route) => {
          this.$router.push(route);
        });
        Object.keys(data).forEach((key) => {
          this[key] = data[key];
        });
      }
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.onResize);
    },

    watch: {
      $route(to, from) {
        this.show_right_menu = false;
        // 只处理已经在自己的个人文库时路由到 /book/self-uid 一种情况
        if (to.name === "book-uid-detail" && to.params.uid === from.params.uid && !to.params.detail){
          const data = this.resArticleList;
          handleRedirect(data, to.params.uid, '', (route) => {
            this.$router.push(route);
          });
        }
      }
    },
    async asyncData(app) {
      const {route, store, redirect} = app;
      return initData(route, store, redirect, true);
    },
    methods: {
      registerBus() {
        this.$Bus.$on('clickFixedCatalogueBtn', () => {
          this.show_right_menu = true;
        })
      },
       onResize(){
        this.normalScreen = document.body.clientWidth > 1100 ? "1200px" : "960px";
        this.fullScreen = `${document.body.clientWidth}px`;
      },

      /**
       * 查看文章内容
       *
       * @param id
       */
      handleFileClick(id) {
        this.show_right_menu=false;
      },
      doSearchStruct() {
        this.$router.push({
          name: "search",
          query: { key: this.searchStruct, uid: this.$route.params.uid },
        });
      },
      /**
       * 关注用户
       */
      handleFollow() {
        followUser(this.currentUserInfo.id, !this.currentUserInfo.follow).then((res) => {
          successMsg(res.data.msg);
          this.currentUserInfo.follow = ! this.currentUserInfo.follow;
        });
      },

      /**
       * 同步仓库外部更新
       */
      onSyncRepo() {
        apis.updateRepo().then(() => {
          successMsg('外部更新完成!')
        });
      },
      /**
       * 选中用户目录下拉框时候
       */
      handleSelectStruct(id) {
        if (id) {
          this.handleFileClick(id);
        }
      },
      visibleChange(flag) {
        if (flag) {
          this.$refs.selectStruct.focus();
        } else {
          this.$refs.selectStruct.blur();
        }
      },

      /**
       * 左侧菜单 open
       * @param component
       */
      handleLeftOpen(component) {
        component.$el.querySelector(".file-on").scrollIntoViewIfNeeded();
      },
    }
  }
</script>

<style lang="stylus">
.custom-input{
  .el-input__inner{
    border none
    text-indent 15px
  }
}
</style>

<style lang="stylus" scoped>
  /* 导入全局样式变量 */
  @import '~assets/stylus/variable.styl'

  html, body, #__nuxt, #__layout, .template-container {
    height: 100% !important;
  }
  .content-container {
    position relative
    margin 0 auto
    width 100%
    max-width 960px
    top 5rem
    margin-top 15px
    &::after {
      display table
      content ""
      clear both
    }
  }

  .article-detail-main {
    height: 100%;
    margin: 0 auto;

    .detail-left {
      height: calc(100% - 135px);
      width: 240px;
      position: fixed;
      top: 75px;
      z-index 1;

      .user-info {
        background: #FFF;
        padding: 10px;
        display: flex;
        align-items: center;
        border-radius: border_radius;

        .avatar {
          width: 45px;
          height: 45px;
          border-radius: 100%;
        }

        .user-introduce {
          padding: 0 10px;
        }
      }
      .struct-title {
        text-align center
        font-size 16px
        margin 8px 0
        border-bottom 1px solid #eee
        padding 5px 0
        background-color #FFFFFF
        border-radius  6px
        .prefix-wrap{
          position relative
          display flex
          height 100%
          align-items center
        }
        .prefix-wrap::after {
          content ''
          position absolute
          width 1px
          height 12px
          right -10px
          background-color #DDDDDD
        }
      }
      .struct-panel {
        background: #FFF;
        border-radius: border_radius;
        height: calc(100% - 85px);
        .tree-box {
          background: #FFF;
          height: 100%;
        }
      }
    }
  }

  @media (min-width 1200px) {
    .article-detail-main {
      width: 1200px;
    }
  }

  @media (max-width 1200px) {
    .detail-left {
      display: none;
    }
    .article-detail-main {
      width: 960px;
    }
  }

  @media (max-width 1200px) {
    .content-container {
      padding 0 10px
    }
    .article-detail-main {
      width: 100%;
    }
  }
  @media (max-width 1200px) {
    .article-detail-main {
      width: auto!important;
    }
  }
</style>
